import { AddAPhoto, HideImage } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { GreenText } from 'components'
import { useEffect, useState } from 'react'

interface DamagePhoto1DialogProps {
  damagePhoto?: File
  onClose: () => void
  onDelete: () => void
  onSave: (damagePhoto: File | undefined) => void
  open: boolean
  photo: 1 | 2 | 3
}

export default function DamagePhoto1Dialog({ damagePhoto, onClose, onDelete, onSave, open, photo }: DamagePhoto1DialogProps) {
  const [file, setFile] = useState<File | undefined>(undefined)

  useEffect(() => {
    return () => {
      setFile(undefined)
    }
  }, [])

  return (
    <Dialog open={open}>
      <DialogContent>
        <Grid container spacing={2} alignItems='center'>
          <DialogTitle>Damage Photo {photo}</DialogTitle>

          <Grid item xs={12}>
            <img
              alt={`Damage Photo ${photo}`}
              src={file ? URL.createObjectURL(file) : damagePhoto ? URL.createObjectURL(damagePhoto) : ''}
              style={{ width: '100%' }}
            />
          </Grid>

          <Grid item xs={12}>
            <input
              accept='image/png, image/jpeg'
              hidden
              id={`damagePhoto${photo}File`}
              type='file'
              onChange={e => {
                if (e.target.files && e.target.files.length > 0) {
                  setFile(e.target.files[0])
                }
              }}
            />

            <Button
              color='primary'
              endIcon={<AddAPhoto />}
              fullWidth
              onClick={() => {
                document.getElementById(`damagePhoto${photo}File`)?.click()
              }}
              variant='outlined'
            >
              BROWSE OR TAKE PHOTO
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button
              color='error'
              endIcon={<HideImage />}
              fullWidth
              onClick={() => {
                if (window.confirm(`Are you sure you would like to delete the uploaded Damage Photo ${photo}?`)) {
                  onDelete()
                }
              }}
              variant='outlined'
            >
              DELETE UPLOADED PHOTO
            </Button>
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Photo Previewer:**

Displays a preview of the uploaded photo.

If no photo is uploaded, nothing will be displayed.

**Notes:**

A free-text field for additional notes or comments.

**BROWSE OR TAKE PHOTO Button:**

Clicking this button opens the user’s camera app, allowing 
them to:

Take a new photo and upload it.

Upload an existing photo from their device.

**DELETE UPLOADED PHOTO Button:**

Clicking this button will:

Clear/delete the currently uploaded photo.

Remove it from the Photo Previewer.

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save 
any changes

**SAVE Button:**

Clicking this button will:

Save the uploaded photo to the database and close the dialog`}
            </GreenText>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button color='error' onClick={onClose} variant='text'>
          CANCEL
        </Button>

        <Button
          color='primary'
          onClick={() => {
            onSave(file)
          }}
          variant='contained'
        >
          SAVE
        </Button>
      </DialogActions>
    </Dialog>
  )
}
